import React from "react"

// Figma: 숏폼 재생버튼 업데이트 (node 294:752)
export default function VodIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="4 3 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9389 5.4641L22.9883 11.8435C25.644 13.3767 25.6577 17.205 23.0131 18.7572L11.9637 25.2428C9.29717 26.8079 5.93893 24.8851 5.93893 21.7931L5.93893 8.9282C5.93893 5.849 9.27227 3.9245 11.9389 5.4641Z"
        fill="#EA4335"
      />
      <path
        d="M15.2886 7.65812L20.3237 10.5953C20.5887 10.7498 20.6532 11.1044 20.4598 11.3425L14.3507 18.8616C14.3356 18.8801 14.3193 18.8975 14.3017 18.9137L9.15702 23.6624C8.78416 24.0066 8.19502 23.6407 8.33821 23.1539L10.3155 16.4321C10.3239 16.4037 10.3347 16.3761 10.348 16.3496L14.5894 7.86641C14.7186 7.60809 15.0391 7.5126 15.2886 7.65812Z"
        fill="url(#vodPlayGrad)"
        fillOpacity="0.7"
        style={{ mixBlendMode: "soft-light" }}
      />
      <path
        d="M13.9029 9.69985C14.0263 9.48892 14.2754 9.38619 14.5113 9.44985C14.7473 9.51376 14.9115 9.72789 14.9117 9.97231V13.7643H17.0787C17.2724 13.7645 17.4519 13.8679 17.5484 14.0358C17.6449 14.2038 17.6439 14.4113 17.5465 14.5788L13.7545 21.0788C13.6313 21.2897 13.382 21.3922 13.1461 21.3288C12.9099 21.2649 12.7457 21.05 12.7457 20.8053V17.0143H10.5787C10.3848 17.0143 10.2056 16.91 10.109 16.7418C10.0127 16.5738 10.0135 16.3672 10.1109 16.1998L13.9029 9.69985Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="vodPlayGrad"
          x1="4.42706"
          y1="16.6018"
          x2="22.1395"
          y2="6.37551"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFAE9B" />
          <stop offset="1" stopColor="#99685D" />
        </linearGradient>
      </defs>
    </svg>
  )
}
